import { cn } from '../../lib/utils';
import { progressColor } from '../../utils/helpers';

export function LumynProgress({ value = 0, size = 'default', showLabel = false, className }) {
  const heights = { thin: 'h-1', default: 'h-2', thick: 'h-3' };
  const pct = Math.min(100, Math.max(0, value));
  const color = progressColor(pct);

  return (
    <div className={cn('w-full', className)} data-testid="progress-bar">
      {showLabel && <p className="text-xs text-muted-foreground mb-1">{pct.toFixed(0)}%</p>}
      <div className={cn('w-full rounded-full bg-muted overflow-hidden', heights[size])}>
        <div
          className={cn('h-full rounded-full transition-[width] duration-500 ease-in-out', color)}
          style={{ width: `${pct}%` }}
        />
      </div>
    </div>
  );
}
